import React, { useEffect, useState, useRef } from "react";
import { gsap } from "gsap";
import { Flip } from "gsap/Flip";
import classNames from "classnames";
import styles from "./UploadCV.module.scss";
import { useGSAP } from "@gsap/react";
import UploadCVIcon from "../assets/svgs/UploadCVIcon.svg";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

gsap.registerPlugin(Flip);

const UploadCV = ({ handleCloseUploadCV }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    surname: "",
    email: "",
    positionApplyingFor: "",
    agreeToPrivacyPolicy: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const [cvFile, setCvFile] = useState(null);

  const handleCVUpload = (e) => {
    setCvFile(e.target.files[0]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.agreeToPrivacyPolicy) {
      alert("You must agree to the privacy policy to submit the form.");
      return;
    }

    const formDataToSend = new FormData();

    for (const key in formData) {
      formDataToSend.append(key, formData[key]);
    }

    if (cvFile) {
      formDataToSend.append("cvFile", cvFile, cvFile.name);
    }

    // Log FormData contents
    console.log(...formDataToSend.entries());

    fetch(
      "https://cloud.activepieces.com/api/v1/webhooks/glQADITFt77VhHap8ypNL/",
      {
        method: "POST",
        body: formDataToSend,
      }
    )
      .then((response) => {
        if (!response.ok) {
          return response.text().then((err) => {
            throw new Error(`${response.status} ${err}`);
          });
        }
        return response.json();
      })
      .then((data) => {
        console.log("Success:", data);
        alert("CV uploaded successfully!");
        handleUploadSuccess();
        setFormData({
          firstName: "",
          surname: "",
          email: "",
          positionApplyingFor: "",
          agreeToPrivacyPolicy: false,
        });
        setCvFile(null);
      })
      .catch((error) => {
        console.error("Error:", error);
        alert(`Error uploading CV: ${error.message}`);
      });
  };

  const handleUploadSuccess = () => {
    handleCloseUploadCV();
  };

  useGSAP(() => {});

  return (
    <section className={styles.uploadCVContainer}>
      <div className={styles.grid}>
        <div className={styles.topBar}>
          <div className={styles.title}>Upload your CV</div>
          <div className={styles.closeButton} onClick={handleCloseUploadCV}>
            X
          </div>
        </div>
        <div className={styles.candidateForm}>
          <div className={styles.candidateInformation}>
            <DialogContent>
              <TextField
                autoFocus
                margin="dense"
                id="firstName"
                label="First Name"
                name="firstName"
                type="text"
                fullWidth
                value={formData.firstName}
                onChange={handleChange}
                required
              />
              <TextField
                autoFocus
                margin="dense"
                id="surnameName"
                label="Surname"
                name="surname"
                type="text"
                fullWidth
                value={formData.surname}
                onChange={handleChange}
                required
              />
              <TextField
                autoFocus
                margin="dense"
                id="email"
                label="Email"
                name="email"
                type="email"
                fullWidth
                value={formData.email}
                onChange={handleChange}
                required
              />
              <TextField
                autoFocus
                margin="dense"
                id="positionApplyingFor"
                label="Position Applying For"
                name="positionApplyingFor"
                type="text"
                fullWidth
                value={formData.positionApplyingFor}
                onChange={handleChange}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="agreeToPrivacyPolicy"
                    checked={formData.agreeToPrivacyPolicy}
                    onChange={handleChange}
                    color="primary"
                  />
                }
                label="I agree to the Privacy Policy"
              />
            </DialogContent>
          </div>
          <div
            className={styles.cvUpload}
            onClick={() => document.getElementById("cvFileInput").click()}
          >
            <img
              className={styles.uploadIcon}
              src={UploadCVIcon}
              alt="Upload CV Icon"
            />
            <input
              type="file"
              id="cvFileInput"
              name="cvFile"
              onChange={handleCVUpload}
              accept=".pdf,.doc,.docx"
              style={{ display: "none" }} // Hides the input
            />
            {cvFile && <p>Uploaded: {cvFile.name}</p>}
          </div>
        </div>
        <div className={styles.blurb}>
          After providing your information and CV we will contact shortly based
          on your fit for the role.
        </div>
        <div className={styles.buttonContainer}>
          <div className={styles.button} onClick={handleSubmit}>
            Upload Your CV
          </div>
        </div>
      </div>
    </section>
  );
};

export default UploadCV;
